import * as React from 'react';
import { Button } from '@blueprintjs/core';

const PreviewBanner = ({episode}) => {
  return (
    <div className="PreviewBanner">
      <div>You are watching a short excerpt from our {Math.round(episode.duration / 60)} minute episode "<strong>{episode.name}</strong>". </div>

    <Button intent="success" 
      text="Buy the complete course" 
      icon="tick-circle" 
      onClick={() => (window as any).openCheckout() } />

    </div>
  );
}

const PreviewFinishedOverlay = ({episode, nextEpisode, onClickNext}) => {
  return (
    <div className="PreviewFinishedOverlay">
      <div className="bp3-dialog">
        <h3>Buy the course to get the full episode</h3>

        <ul className="_benefits">
    <li>Full <strong>{episode.name}</strong> episode is {Math.round(episode.duration / 60)} minutes</li>
          <li>Perfect subtitles</li>
          <li>Filmed in 4K</li>
          <li>Just one of over 102 videos in the course.</li>
          <li>Lifetime access for just {(window as any).COURSE.price}</li>
        </ul>


      <Button intent="success" 
    text={`Buy now for ${(window as any).COURSE.price}`} 
          icon="tick-circle" 
          onClick={() => (window as any).openCheckout() } />


        <div style={{borderTop: '1px solid #444', marginTop: 20}}>
    Or watch another preview... <strong><a href="#" onClick={onClickNext}>Up next: {nextEpisode.name}</a></strong>
        </div>
      </div>
    </div>
  );
}

type PreviewPlayerProps = {
  episode: {
    id: number,
    teaser: any,
    thumbnail_url: string,
  },
  nextEpisode: any,
  onFinish: Function,
}

export default class PreviewPlayer extends React.Component<PreviewPlayerProps> {
  private player;

  state = {
    isFinished: false,
  }

  componentDidMount = () => {
    this.player = (window as any).videojs('preview_video');
    this.player.on('ended', () => {
      this.handleFinish();
    });
  }

  handleFinish = () => {
    this.setState({
      isFinished: true,
    })
    console.log("Fiinished...");
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.episode.id !== this.props.episode.id) {
      this.setState({
        isFinished: false,
      });
      
      this.player.src({
        type: "video/mp4", src: nextProps.episode.teaser.url,
      });
      this.player.play();
    }
  }

  render() {
    const { episode, nextEpisode } = this.props;
    let { isFinished } = this.state;

    return (
      <div className="preview-player">
      <video id="preview_video" className="video-js" controls preload="auto" poster={episode.thumbnail_url.replace('w250', 'h360')}>
          {episode.teaser && <source type="video/mp4" src={episode.teaser.url} />}

        </video>
      { isFinished && <PreviewFinishedOverlay 
          episode={episode}  
          nextEpisode={nextEpisode} 
          onClickNext={() => this.props.onFinish()}
        /> }
        <PreviewBanner episode={episode}  />
      </div>  
    ); 
  }
}
